module.exports = __webpack_public_path__ + "media/images/yourcf-5ae4bf86559c4238c3ef35c5ec834774.gif";